/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from '@emotion/styled';

import CreatorProfileCard from './CreatorProfileCard';
import TemplateCard from './TemplateCard';

function LandingContent({ creator, page }) {
  const templates = creator.templates.map(t => {
    if (t.preview_list?.story._1_1) {
      t.dimension = '1:1';
    } else if (t.preview_list?.story._16_9) {
      t.dimension = '16:9';
    } else if (t.preview_list?.story._9_16) {
      t.dimension = '9:16';
    }

    return t;
  });

  return (
    <div className="profile-landing-templates">
      <Container className="container grid gap-4">
        <div className="flex justify-center creator-profile-card">
          <CreatorProfileCard
            top="-90px"
            width="250px"
            showOtherInfo={true}
            profile={creator}
            page={page}
          />
        </div>
        <TemplateGrid className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
          <div>
            {templates
              .filter((d, index) => index % 3 === 0)
              .map(template => (
                <TemplateCard template={template} key={template.id} />
              ))}
          </div>
          <div>
            {templates
              .filter((d, index) => index % 3 === 1)
              .map(template => (
                <TemplateCard template={template} key={template.id} />
              ))}
          </div>
          <div>
            {templates
              .filter((d, index) => index % 3 === 2)
              .map(template => (
                <TemplateCard template={template} key={template.id} />
              ))}
          </div>
        </TemplateGrid>
      </Container>
    </div>
  );
}

export default LandingContent;

const Container = styled.div`
  grid-template-columns: 1fr 3fr;
  @media only screen and (max-width: 700px) {
    grid-template-columns: 1fr;
  }

  & > div {
    padding: 10px;
  }
`;

const TemplateGrid = styled.div`
  color: #fff;
  font-family: 'Inter';
  margin-top: 40px;

  & > div {
    padding: 1rem;
    height: fit-content;
  }
`;
